import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AlertaService } from "../../services/alerta.service";
import { catchError, exhaustMap, map, tap } from "rxjs/operators";
import { of } from "rxjs";
import { FormulaGroupService } from "../../services/formula-group.service";
import { findFormulaGroupAct, loadFormulaGroupByIdAct, saveFormulaGroupAct, saveSuccessFormulaGroupAct, 
    setViolationsFormulaGroupAct, showMsgErrorAct, updateFormulaGroupAct, updateSuccessFormulaGroupAct } from "./formula-group.action";


@Injectable()
export class formulaGroupEffects {

    private actions$ = inject(Actions);
    private router = inject(Router);
    private formulaGroupService = inject(FormulaGroupService);
    private alerta = inject(AlertaService);

    findFormulaGroupEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findFormulaGroupAct),
            exhaustMap(action => this.formulaGroupService.findFormulaGroupById(action.id)
                .pipe(
                    map(formulaGroup => loadFormulaGroupByIdAct({ formulaGroup })),
                    catchError(error => {
                        if(error.status == 500) {
                            this.alerta.error("Se ha precentado un error interno", {
                                detail: error.error.details ,
                                onAccept: () => {
                                  this.router.navigate(['/formulasGroup']);
                                }}); // . stack -> mas detalle
                            return of();
                        }else {
                            //return of(showMsgErrorAct({ error }));
                            this.alerta.error("Se ha precentado un error interno: ", {detail: error.message});
                            return of();
                        }
                    })
                ))
        )
    );

    saveFormulaGroupEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(saveFormulaGroupAct),
            exhaustMap(action => this.formulaGroupService.createFormulaGroup(action.formulaGroupNew)
                .pipe(
                    map(formulaGroupNew => saveSuccessFormulaGroupAct({ formulaGroupNew })),
                    catchError(error => (error.status == 400) ? of(setViolationsFormulaGroupAct({ formulaGroupForm: action.formulaGroupNew, violations: this.violationsToObject(error.error.parameterViolations) })) 
                    : of(showMsgErrorAct({ error }))
                    
                    )
                )
            )
        )
    );

    showMsgErrorEffect$ = createEffect(() =>
        this.actions$.pipe(
          ofType(showMsgErrorAct),
          tap(action => {
            const detail = action.error?.error?.message || action.error?.message || null;
            //console.log('showMsgErrorEffect 111:');
            this.alerta.error(
              'Se ha presentado un error interno Grupo Formulas',
              detail ? { detail } : undefined
            );
            //console.log('showMsgErrorEffect 222:');
          })
        ),
        { dispatch: false }
      );

    saveSuccessFormulaGroupEffect$ = createEffect(() => this.actions$.pipe(
        ofType(saveSuccessFormulaGroupAct),
        tap(() => {
            this.router.navigate(['/formulasGroup']);
            this.alerta.correct("Grupo Formulas creado con exito!");
        })
    ), { dispatch: false });

    updateFormulaGroupEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(updateFormulaGroupAct),
            exhaustMap(action => this.formulaGroupService.updateFormulaGroup(action.formulaGroupUpdated)
                .pipe(
                    map(formulaGroupUpdated => updateSuccessFormulaGroupAct({ formulaGroupUpdated })),
                    catchError(error => {
                        if(error.status == 400) {
                            return of(setViolationsFormulaGroupAct({ formulaGroupForm: action.formulaGroupUpdated, violations: this.violationsToObject(error.error.parameterViolations)})) ;
                        }else {
                            return of(showMsgErrorAct({ error }));
                        }
                    })
                )
            )
        )
    );

    updateSuccessFormulaGroupEffect$ = createEffect(() => this.actions$.pipe(
        ofType(updateSuccessFormulaGroupAct),
        tap(() => {
            this.router.navigate(['/formulasGroup']);
            this.alerta.correct("Grupo Formulas editado con exito!");
        })
    ), {dispatch: false});

    violationsToObject(violationsList: []): any {
        return violationsList.reduce((obj: { [x: string]: any; }, item: { path: string; message: any; }) => {
            obj[item.path.slice(item.path.indexOf('.') + 1)] = item.message;
            return obj;
        }, {});
    };
    
}